import { ensureCsrfCookie, xsrfHeaders } from './authApi';
import { resolveApiBaseUrl } from '../utils/apiBase';

const API = () => resolveApiBaseUrl();

async function jsonFetch(path, options = {}) {
  await ensureCsrfCookie();
  const response = await fetch(`${API()}${path}`, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...xsrfHeaders(),
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers,
    },
    ...options,
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || err.error || `Request failed (${response.status})`);
  }
  if (response.status === 204) return null;
  return response.json();
}

/** BR-05 — Pipeline Ops dashboard snapshot. */
export async function fetchPipelineOps(runId) {
  const q = runId ? `?runId=${encodeURIComponent(runId)}` : '';
  return jsonFetch(`/v1/admin/pipeline-ops${q}`);
}

/** Proxy pause|resume|stop to DGX corpus plow. */
export async function controlCorpusPlow(action) {
  return jsonFetch(`/v1/admin/pipeline-ops/plow?action=${encodeURIComponent(action)}`, {
    method: 'POST',
  });
}

/** CORPUS-STATS-01 — sync full recount of Mongo corpus quality counters. */
export async function rebuildCorpusStats() {
  return jsonFetch(`/v1/admin/pipeline-ops/corpus-stats/rebuild`, {
    method: 'POST',
  });
}
